module.exports = __webpack_public_path__ + "static/media/video6.6130dd8.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/video6.mp4
// module id = biEp
// module chunks = 0